// extracted by mini-css-extract-plugin
export default {"page":"a0-z","cartModal":"b0-z","checkout":"c0-z","placeholder":"d0-z","account":"e0-z"};